export const languageOptions = [
  { value: "abk", label: "Abkhazian" },
  { value: "aar", label: "Afar" },
  { value: "afr", label: "Afrikaans" },
  { value: "aka", label: "Akan" },
  { value: "alb", label: "Albanian" },
  { value: "amh", label: "Amharic" },
  { value: "ara", label: "Arabic" },
  { value: "arg", label: "Aragonese" },
  { value: "arm", label: "Armenian" },
  { value: "asm", label: "Assamese" },
  { value: "ava", label: "Avaric" },
  { value: "ave", label: "Avestan" },
  { value: "aym", label: "Aymara" },
  { value: "aze", label: "Azerbaijani" },
  { value: "bam", label: "Bambara" },
  { value: "bak", label: "Bashkir" },
  { value: "baq", label: "Basque" },
  { value: "bel", label: "Belarusian" },
  { value: "ben", label: "Bengali" },
  { value: "bih", label: "Bihari" },
  { value: "bis", label: "Bislama" },
  { value: "bos", label: "Bosnian" },
  { value: "bre", label: "Breton" },
  { value: "bul", label: "Bulgarian" },
  { value: "bur", label: "Burmese" },
  { value: "cat", label: "Catalan" },
  { value: "cha", label: "Chamorro" },
  { value: "che", label: "Chechen" },
  { value: "ny", label: "Chichewa" },
  { value: "chi", label: "Chinese" },
  { value: "chv", label: "Chuvash" },
  { value: "cor", label: "Cornish" },
  { value: "cos", label: "Corsican" },
  { value: "cre", label: "Cree" },
  { value: "hrv", label: "Croatian" },
  { value: "cze", label: "Czech" },
  { value: "dan", label: "Danish" },
  { value: "div", label: "Divehi" },
  { value: "dut", label: "Dutch" },
  { value: "dzo", label: "Dzongkha" },
  { value: "eng", label: "English" },
  { value: "epo", label: "Esperanto" },
  { value: "est", label: "Estonian" },
  { value: "ewe", label: "Ewe" },
  { value: "fao", label: "Faroese" },
  { value: "fij", label: "Fijian" },
  { value: "fin", label: "Finnish" },
  { value: "fre", label: "French" },
  { value: "fry", label: "Western Frisian" },
  { value: "ful", label: "Fulah" },
  { value: "gla", label: "Scottish Gaelic" },
  { value: "glg", label: "Galician" },
  { value: "lug", label: "Ganda" },
  { value: "geo", label: "Georgian" },
  { value: "ger", label: "German" },
  { value: "gre", label: "Greek" },
  { value: "grn", label: "Guarani" },
  { value: "guj", label: "Gujarati" },
  { value: "hat", label: "Haitian" },
  { value: "hau", label: "Hausa" },
  { value: "heb", label: "Hebrew" },
  { value: "her", label: "Herero" },
  { value: "hin", label: "Hindi" },
  { value: "hmo", label: "Hiri Motu" },
  { value: "hun", label: "Hungarian" },
  { value: "ice", label: "Icelandic" },
  { value: "ido", label: "Ido" },
  { value: "ibo", label: "Igbo" },
  { value: "ind", label: "Indonesian" },
  { value: "ina", label: "Interlingua" },
  { value: "ile", label: "Interlingue" },
  { value: "iku", label: "Inuktitut" },
  { value: "ipk", label: "Inupiaq" },
  { value: "gle", label: "Irish" },
  { value: "ita", label: "Italian" },
  { value: "jpn", label: "Japanese" },
  { value: "jav", label: "Javanese" },
  { value: "kal", label: "Kalaallisut" },
  { value: "kan", label: "Kannada" },
  { value: "kau", label: "Kanuri" },
  { value: "kas", label: "Kashmiri" },
  { value: "kaz", label: "Kazakh" },
  { value: "khm", label: "Khmer" },
  { value: "kik", label: "Kikuyu" },
  { value: "kin", label: "Kinyarwanda" },
  { value: "kir", label: "Kirghiz" },
  { value: "kom", label: "Komi" },
  { value: "kon", label: "Kongo" },
  { value: "kor", label: "Korean" },
  { value: "kur", label: "Kurdish" },
  { value: "kua", label: "Kwanyama" },
  { value: "lao", label: "Lao" },
  { value: "lat", label: "Latin" },
  { value: "lav", label: "Latvian" },
  { value: "lim", label: "Limburgan" },
  { value: "lin", label: "Lingala" },
  { value: "lit", label: "Lithuanian" },
  { value: "lub", label: "Luba-Katanga" },
  { value: "ltz", label: "Luxembourgish" },
  { value: "mac", label: "Macedonian" },
  { value: "mlg", label: "Malagasy" },
  { value: "may", label: "Malay" },
  { value: "mal", label: "Malayalam" },
  { value: "mlt", label: "Maltese" },
  { value: "glv", label: "Manx" },
  { value: "mao", label: "Maori" },
  { value: "mar", label: "Marathi" },
  { value: "mah", label: "Marshallese" },
  { value: "mon", label: "Mongolian" },
  { value: "nau", label: "Nauru" },
  { value: "nav", label: "Navajo" },
  { value: "ndo", label: "Ndonga" },
  { value: "nep", label: "Nepali" },
  { value: "nde", label: "North Ndebele" },
  { value: "sme", label: "Northern Sami" },
  { value: "nor", label: "Norwegian" },
  { value: "nob", label: "Norwegian Bokmål" },
  { value: "nno", label: "Norwegian Nynorsk" },
  { value: "iii", label: "Nuosu" },
  { value: "oci", label: "Occitan" },
  { value: "oji", label: "Ojibwa" },
  { value: "ori", label: "Oriya" },
  { value: "orm", label: "Oromo" },
  { value: "oss", label: "Ossetian" },
  { value: "pli", label: "Pali" },
  { value: "pan", label: "Panjabi" },
  { value: "pus", label: "Pashto" },
  { value: "per", label: "Persian" },
  { value: "pol", label: "Polish" },
  { value: "por", label: "Portuguese" },
  { value: "que", label: "Quechua" },
  { value: "rum", label: "Romanian" },
  { value: "roh", label: "Romansh" },
  { value: "rus", label: "Russian" },
  { value: "smo", label: "Samoan" },
  { value: "sag", label: "Sango" },
  { value: "san", label: "Sanskrit" },
  { value: "srd", label: "Sardinian" },
  { value: "srp", label: "Serbian" },
  { value: "sna", label: "Shona" },
  { value: "snd", label: "Sindhi" },
  { value: "sin", label: "Sinhala" },
  { value: "slo", label: "Slovak" },
  { value: "slv", label: "Slovenian" },
  { value: "som", label: "Somali" },
  { value: "nbl", label: "South Ndebele" },
  { value: "sot", label: "Southern Sotho" },
  { value: "spa", label: "Spanish" },
  { value: "sun", label: "Sundanese" },
  { value: "swa", label: "Swahili" },
  { value: "ssw", label: "Swati" },
  { value: "swe", label: "Swedish" },
  { value: "tgl", label: "Tagalog" },
  { value: "tah", label: "Tahitian" },
  { value: "tgk", label: "Tajik" },
  { value: "tam", label: "Tamil" },
  { value: "tat", label: "Tatar" },
  { value: "tel", label: "Telugu" },
  { value: "tha", label: "Thai" },
  { value: "tib", label: "Tibetan" },
  { value: "tir", label: "Tigrinya" },
  { value: "ton", label: "Tonga" },
  { value: "tso", label: "Tsonga" },
  { value: "tsn", label: "Tswana" },
  { value: "tur", label: "Turkish" },
  { value: "tuk", label: "Turkmen" },
  { value: "twi", label: "Twi" },
  { value: "uig", label: "Uighur" },
  { value: "ukr", label: "Ukrainian" },
  { value: "urd", label: "Urdu" },
  { value: "uzb", label: "Uzbek" },
  { value: "ven", label: "Venda" },
  { value: "vie", label: "Vietnamese" },
  { value: "vol", label: "Volapük" },
  { value: "wln", label: "Walloon" },
  { value: "wel", label: "Welsh" },
  { value: "wol", label: "Wolof" },
  { value: "xho", label: "Xhosa" },
  { value: "yid", label: "Yiddish" },
  { value: "yor", label: "Yoruba" },
  { value: "zha", label: "Zhuang" },
  { value: "zul", label: "Zulu" },
];

export const narrowedLanguageOptions = [
  { value: "ara", label: "Arabic" },
  { value: "hrv", label: "Croatian" },
  { value: "dut", label: "Dutch; Flemish" },
  { value: "eng", label: "English" },
  { value: "fre", label: "French" },
  { value: "ger", label: "German" },
  { value: "oth", label: "Other" },
  { value: "por", label: "Portuguese" },
  { value: "rum", label: "Romanian" },
  { value: "rus", label: "Russian" },
  { value: "spa", label: "Spanish; Castilian" },
];
